export const otpTimerRangeSeconds = 59;

export const otpTimerStorageKey = `logto:${window.location.origin}:otp-timer-expiry`;

export const getOtpTimerExpiry = (): Date => {
  const stored = sessionStorage.getItem(otpTimerStorageKey);

  if (stored) {
    const expiry = new Date(Number(stored));

    if (expiry > new Date()) {
      return expiry;
    }
  }

  return newOtpTimerExpiry();
};

export const newOtpTimerExpiry = (): Date => {
  const now = new Date();
  now.setSeconds(now.getSeconds() + otpTimerRangeSeconds);
  return now;
};

export const storeOtpTimerExpiry = (expiry: Date): void => {
  sessionStorage.setItem(otpTimerStorageKey, String(expiry.getTime()));
};
